import envConfig from 'configs/envConfig';

const urls = {
  baseUrl: envConfig('baseUrl')
};
export default urls;
